export const featureFlags = Object.freeze({
  COMPANY_ACTIVITY_TAB: false,
})
